import React from "react";
import { StepperChildrenProps } from "..";
import { Box, Typography } from "@mui/material";
import LinkFileRedirectDownload from "../../../../../LinkFileRedirectDownload";
import Condicional from "./Condicional";
import BtnBaixarTodosArquivos from "../../../../../BtnBaixarTodosArquivos";
import InfoContabeis from "./InfoBox/InfoContabeis";
import InfoRateio from "./InfoBox/InfoRateio";
import InfoRetencao from "./InfoBox/InfoRetencao";
import InfoAnaliseDoc from "./InfoBox/InfoAnaliseDoc";
import InfoRemoverTitulo from "./InfoBox/InfoRemoverTitulo";
import InfoDadosPropriedade from "./InfoBox/InfoDadosPropriedade/InfoDadosPropriedade";
import InfoCotaCapital from "./InfoBox/InfoCotaCapital";
import InfoDadosCadastrais from "./InfoBox/InfoDadosCadastrais";
import InfoAnaliseCredito from "./InfoBox/InfoAnaliseCredito";
import AcaoExternaContent from "./AcoesExternas/AcoesExternasContent";

export default function LabelContent({
    tarefa,
    codigo
}: LabelContentProps) {

    let renderComponent = <React.Fragment />

    if ((tarefa.tipo === "Condicional" || tarefa.tipo === "Condicional automática") && tarefa.resolvida_em) {
        renderComponent = <Condicional resposta={tarefa?.resposta?.resposta} />
    }

    return (
        <>
            {renderComponent}

            {
                tarefa.observacoes_cancelamento &&
                <Typography component="div" variant="caption" mt={1} color="error" style={{ whiteSpace: 'pre-line' }}>Observações:<b>{tarefa.observacoes_cancelamento}</b></Typography>
            }

            {
                tarefa.observacoes &&
                <Typography component="div" variant="caption" mt={1} style={{ whiteSpace: 'pre-line' }}>
                    Observações: {"\n"}
                    <b>{tarefa.observacoes}</b>
                </Typography>
            }

            {tarefa.tipo === "Ação externa" && <AcaoExternaContent tarefa={tarefa} />}

            <Box my={1}>
                {
                    tarefa.arquivos && tarefa.arquivos.length > 0 &&
                    tarefa.arquivos.map(({ id, nome }) => (
                        <LinkFileRedirectDownload {...{ id, nome }} key={id} />
                    ))
                }
                {
                    tarefa.arquivos && tarefa.arquivos.length > 1 &&
                    <BtnBaixarTodosArquivos {...{ codigo }} arquivos={tarefa.arquivos} />
                }


                {
                    (tarefa.resposta && tarefa.formulario) && tarefa.formulario.spec.map((s) => {

                        const resposta = tarefa.resposta[s.name] || tarefa.resposta

                        if (s.type === "file") return (<React.Fragment />)

                        if (s.type === "form_adicionar_retencao") return (<InfoRetencao {...{resposta}} />)
                        if (s.type === "form_aplicar_rateio") return (<InfoRateio {...{resposta}} />)
                        if (s.type === "form_informacoes_contabeis") return (<InfoContabeis {...{resposta}} />)
                        if (s.type === "form_analise_documentacao") return (<InfoAnaliseDoc {...{resposta}} />)
                        if (s.type === "form_remover_titulo_ap_global") return (<InfoRemoverTitulo {...{resposta}} />)
                        if (s.type === "form_dados_cadastrais") return (<InfoDadosCadastrais {...{resposta}} />)
                        if (s.type === "form_dados_propriedade") return (<InfoDadosPropriedade {...{resposta}} />)
                        if (s.type === "form_cota_capital") return (<InfoCotaCapital {...{resposta}} />)
                        if (s.type === "form_tipo_operacao_analise_credito") return (<InfoAnaliseCredito {...{resposta}} />)

                        return (
                            <Typography variant="caption" component='div' my={0.5}>{s.label}: <b>{tarefa.resposta[s.name]}</b></Typography>
                        )
                    })
                }
            </Box>
        </>
    )
}

interface LabelContentProps extends StepperChildrenProps {
    usuarioSolicitante: string
    codigo: string
}